import React from 'react';
import { TFinalTest } from '../../../../store/finalTest/types';
import { TAnswerTest } from '../../../../store/interactive/types';
import { Circle } from '../../../../test/components/Circle';
import { Hint } from '../../../ui/Hint';

interface ContentProps {
  type: 'pass' | 'review';
  currentQuestion: number;
  value: TAnswerTest[];
  test: TFinalTest;
  changeValue?: (answerId: number, questionId: number) => void;
}

export const Content: React.FC<ContentProps> = React.memo(({ type, test, value, currentQuestion, changeValue }) => {
  const [isFocus, setIsFocus] = React.useState(false);

  const checkValue = (id: number, isCorrect: number) => {
    if (type === 'pass') {
      const answer = value.find((item) => item.answerId === id);
      return !!answer ? 'tda__active-itm' : '';
    }
    if (type === 'review') {
      const answer = value.find((item) => item.answerId === id);
      return !!answer ? `tda__cheked-itm__${!!isCorrect}` : `tda__right-itm__${!!isCorrect}`;
    }
    return '';
  };

  return (
    <div className="tda__wrapper" style={{ width: '100%' }}>
      <div className="tda__circleTextWrapper">
        <Circle num={+((currentQuestion / test.questions.length) * 100).toFixed()} currentQuestion={currentQuestion} />
        <span>із {test.questions.length} запитань</span>
      </div>
      <div className="tda__testQWrapper" style={{ width: '100%' }}>
        <h5>{`Тема. ${test.title}`}</h5>
        <span style={{ fontSize: '18px' }}>{`${test.questions[currentQuestion].name}`}</span>
        <ul>
          {test.questions[currentQuestion].answers.map((answer) => (
            <li
              className={checkValue(answer.id, answer.is_correct)}
              key={answer.id}
              onClick={() => changeValue && changeValue(answer.id, test.questions[currentQuestion].id)}
              onMouseMove={() => !!answer.is_correct && setIsFocus(true)}
              onMouseLeave={() => !!answer.is_correct && setIsFocus(false)}
            >
              {answer.name}
            </li>
          ))}
        </ul>
      </div>
      {isFocus && type === 'review' && <Hint />}
    </div>
  );
});
